module.exports = __webpack_public_path__ + "img/istobal-logo.2c827575.png";